import { useCallback, useState } from "react"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { useAlertsDispatchContext } from "@l2r-front/l2r-query"
import { I18N_NAMESPACE } from "@l2r-front/l2r-shared-campaign"
import { UiModal } from "@l2r-front/l2r-ui"

import { CampaignAddForm } from "../../forms/CampaignAddForm"

type CampaignCreateModalProps = {
    className?: string,
    open: boolean,
    onClose: () => void,
}

const POPUP_HEIGHT = 654
const POPUP_WIDTH = 514

export function CampaignCreateModal(props: CampaignCreateModalProps) {

    const {
        className,
        open,
        onClose,
    } = props

    const [hasOngoingModifications, setHasOngoingModifications] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const { t } = useTranslation([I18N_NAMESPACE])
    const { setAlert } = useAlertsDispatchContext()

    const handleClose = useCallback((checkModifications = true) => {
        if (checkModifications && hasOngoingModifications) {
            setAlert({
                alertTitle: t(I18N_NAMESPACE, "containers.campaignCreateModal.alert.title"),
                cancelText: t(I18N_NAMESPACE, "containers.campaignCreateModal.alert.cancelButton"),
                confirmText: t(I18N_NAMESPACE, "containers.campaignCreateModal.alert.confirmButton"),
                callback: () => {
                    setHasOngoingModifications(false)
                    onClose()
                },
                open: true,
            })
        } else {
            setHasOngoingModifications(false)
            onClose()
        }
    }, [hasOngoingModifications, t, onClose, setAlert])

    return <UiModal
        className={className}
        id="campaign-create-modal"
        height={POPUP_HEIGHT}
        width={POPUP_WIDTH}
        open={open}
        onClose={handleClose}
        title={t(I18N_NAMESPACE, "containers.campaignCreateModal.title")}
        showLoader={isSubmitting}
    >
        <CampaignAddForm
            onClose={handleClose}
            onChange={setHasOngoingModifications}
            onSubmitting={setIsSubmitting} />
    </UiModal>
}